import { __exports as IsValidDurationRecord } from "../../../../../_virtual/IsValidDurationRecord.mjs";
import require$$0 from "../../../../../_virtual/index2.mjs";
import { __require as requireConstants } from "../constants.mjs";
import { __require as requireDurationRecordSign } from "./DurationRecordSign.mjs";
var hasRequiredIsValidDurationRecord;
function requireIsValidDurationRecord() {
  if (hasRequiredIsValidDurationRecord) return IsValidDurationRecord;
  hasRequiredIsValidDurationRecord = 1;
  Object.defineProperty(IsValidDurationRecord, "__esModule", { value: true });
  IsValidDurationRecord.IsValidDurationRecord = void 0;
  var ecma402_abstract_1 = require$$0;
  var constants_1 = requireConstants();
  var DurationRecordSign_1 = requireDurationRecordSign();
  function IsValidDurationRecord$1(record) {
    var sign = (0, DurationRecordSign_1.DurationRecordSign)(record);
    for (var _i = 0, TABLE_1_1 = constants_1.TABLE_1; _i < TABLE_1_1.length; _i++) {
      var key = TABLE_1_1[_i];
      var v = record[key];
      (0, ecma402_abstract_1.invariant)(isFinite(Number(v)), "".concat(key, " is not finite"));
      if (v < 0 && sign > 0) {
        return false;
      }
      if (v > 0 && sign < 0) {
        return false;
      }
    }
    return true;
  }
  IsValidDurationRecord.IsValidDurationRecord = IsValidDurationRecord$1;
  return IsValidDurationRecord;
}
export {
  requireIsValidDurationRecord as __require
};
